import type { ReactElement } from 'react';
import { useMemo } from 'react';
import { defaultPropTypes } from '../utils';
import ChoiceField from './ChoiceField';
import type { FieldOptions } from '../types';

interface BooleanFieldProps {
    fieldOptions: FieldOptions<'boolean'>;
}

function BooleanField({ fieldOptions }: BooleanFieldProps): ReactElement {
    const booleanFieldOptions = useMemo(() => {
        const { settings } = fieldOptions;

        const options: Array<[boolean, string]> = settings?.invertedOnOffChoices
            ? [
                  [true, gettext('OFF')],
                  [false, gettext('ON')],
              ]
            : [
                  [true, gettext('ON')],
                  [false, gettext('OFF')],
              ];

        return {
            ...fieldOptions,
            settings: {
                ...settings,
                options,
            },
        };
    }, [fieldOptions]);

    return <ChoiceField fieldOptions={booleanFieldOptions} />;
}
BooleanField.propTypes = defaultPropTypes;

export default BooleanField;
